import { schema } from 'normalizr';

const getResponseId = (value, parent) => `${parent.orderId}`;

export const user = new schema.Entity('users');

export const option = new schema.Entity('options', undefined, {
  idAttribute: 'number',
});

export const recipient = new schema.Entity('recipients', {
  owner: user,
});

export const event = new schema.Entity('event', {
  responseOptions: {
    data: [option],
  },
});

export const notification = new schema.Entity('notifications', {
  event,
  recipient,
});

export const response = new schema.Entity(
  'responses',
  {
    notification,
    option,
  },
  { idAttribute: getResponseId },
);

export const audit = new schema.Entity(
  'audits',
  {
    notification,
    response,
  },
  { idAttribute: 'orderId' },
);
export const arrayOfAudits = [audit];
